// extracted by mini-css-extract-plugin
export default {"decidedItem":"DecidedItem_decidedItem__xHx0M"};